(function ($) {
  $(function () {
    const headerAnim = $('header.anim');
    if (!headerAnim.length) return;
    headerAnim.addClass('scrolled');
  });
})(jQuery);
